/*
 * @Author: your name
 * @Date: 2021-08-20 10:15:11
 * @LastEditTime: 2022-01-11 11:45:27
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \bidding-system\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
// import 'element-ui/lib/theme-chalk/index.css';
import SIdentify from '@/untils/SIdentify/SIdentify.vue'
import './common/font/font.css'
import filter from './filter/index'
import ElementUI from 'element-ui';
import x2js from 'x2js' //xml数据处理插件
import './lib/scss/main.scss'

// import './mock/index.js'

import VueAnimateNumber from 'vue-animate-number' // 数字自增
Vue.use(VueAnimateNumber)

Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上

// import 'lib-flexible/flexible'
Vue.use(ElementUI)
// Vue.use(G2)
Vue.config.productionTip = false
Vue.use(SIdentify)

/* 打印组件 */
import Print from 'vue-print-nb'
Vue.use(Print);



// 用于图片拼接路径
// Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL + '/'
Vue.prototype.$baseUrl = API_ADRESS


Vue.prototype.$btnStyle = () => {
    let colorId = localStorage.getItem('colorId');
    switch (colorId) {
        case '1':
            return 'pinkBtn';
        case '2':
            return 'yellowBtn';
        case '3':
            return 'blueBtn';
        default:
            return 'default';
    }
}

Vue.prototype.$Loading = args => {
    args = args || {
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    }

    return Vue.prototype.$loading(args)
}

// 全局过滤器
Object.keys(filter).map(key => { Vue.filter(key, filter[key]) })

Vue.prototype.$echarts = echarts

export let vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
